import dJSON from 'dirty-json';

import Splide from '@splidejs/splide';

const moduleSelector = '.testimonials-3';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      const generateStars = (count) => {
        const starSvg = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-2 -2 28.98 27.88">   <path d="M11.5986 1.0791C11.9231 0.307046 13.0349 0.306995 13.3594 1.0791L13.3604 1.08105L16.1162 7.58496L16.2344 7.86328L16.5342 7.88867L23.5781 8.48633H23.5811C24.4191 8.5531 24.7685 9.60475 24.125 10.1621H24.124L18.7725 14.7998L18.5439 14.9971L18.6123 15.291L20.2168 22.1748C20.4082 22.9999 19.5178 23.6485 18.79 23.208L12.7373 19.5479L12.4795 19.3916L12.2207 19.5469L6.16895 23.1934H6.16797C5.44015 23.6339 4.54968 22.9853 4.74121 22.1602L6.34473 15.2764L6.41309 14.9824L6.18555 14.7852L0.833008 10.1475C0.189386 9.5901 0.538769 8.53835 1.37695 8.47168H1.37988L8.42285 7.87402L8.72363 7.84863L8.84082 7.57129L11.5977 1.08105L11.5986 1.0791Z" fill="#C4AB2F" stroke="#C4AB2F"></path> </svg>';
        return starSvg.repeat(count);
      };

      data.forEach((item) => {
        query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
          <div class="splide__slide">
            <div class="testimonial">
              <div class="stars">
                ${generateStars(item.stars)}
              </div>
              <p class="details">${item.details || ''}</p>
              <p class="author">${item.author || ''}</p>
              ${item.button ? `<a href="${item.link}" class="btn-custom primary">${item.button}</a>` : ''}
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

(() => {
  document.querySelectorAll('.testimonials-3 .splide').forEach((item) => {
    const slider = new Splide(item, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: 30,
      pagination: true,
      arrows: false,
      autoplay: false,
    });
    slider.mount();
  });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
